import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import SproCarrierStatusManagement from './SproCarrierStatusManagement';

const SproCarrierStatusManagementWrapper = (props) => {
    const { themeSelected, onThemechange } = props;

    return (
        <div className="container-fluid">
            <Header {...props} />
            <Navigationbar {...props} />
            <div className="content-wrapper mt-3">
                <SproCarrierStatusManagement themeSelected={themeSelected} />
            </div>
        </div>
    );
};

export default SproCarrierStatusManagementWrapper;